import React, { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './Modal.css';

const Portal: FC<PropsWithChildren> = ({ children }) => {
    const portalElement = document.getElementById('modal');
    if (!portalElement) return null;
    return createPortal(children, portalElement);
};

type ModalProps = {
    isOpen: boolean;
    onClose: () => void;
};

const Modal: FC<PropsWithChildren<ModalProps>> = ({ children, isOpen, onClose }) => {
    const nodeRef = useRef(null);
    
    useEffect(() => {
        const closeOnEscapeKey = (e: KeyboardEvent) => {
            if(e.key === 'Escape') onClose();
        };
        document.body.addEventListener("keydown", closeOnEscapeKey);
        return () => {
            document.body.removeEventListener("keydown", closeOnEscapeKey);
        };
    }, [ onClose ]);

    const onClick = (e: React.MouseEvent) => {
        // Без этого возможно двойное срабатывание при одном клике
        e.stopPropagation();
        onClose();
    };

    // не нужно при использовании CSSTransition
    // if (!isOpen) return null;

	return (
        <Portal>
            <CSSTransition
                in={isOpen}
                timeout={150}
                unmountOnExit
                classNames='Modal'
                nodeRef={nodeRef}
            >
                {/*
                    Обычно попапы убирают при клике мимо них, но тут у клиента
                    странный случай использования: начинают выделять текст внутри попапа,
                    но отпускают мышку за его пределами. При этом происходит срабатывание
                    клика за пределами попапа и он закрывается. Клиенту это не нравится,
                    поэтому он попросил убрать закрытие попапа при клике вне его.
                    <div className='Modal' ref={nodeRef} onClick={onClick}>
                */}
                <div className='Modal' ref={nodeRef}>
                    <div className='ModalInner' onClick={e => e.stopPropagation()}>
                        <div className='ModalClose' onClick={onClick}>
                            <Icon icon={faXmark} fixedWidth/>
                        </div>
                        {children}
                    </div>
                </div>
            </CSSTransition>
        </Portal>
	);
};

export default Modal;
